import { ref, onMounted } from '@vue/composition-api'
import { ChatService } from '../../services';

const useMessage = (request) => {

    const lastMessage = ref(null)

    const setMessage = async () => {
        try {
            lastMessage.value = {loading: true}
            const doc = await ChatService.getRoomsByCampaigns(request.sender.campaign + '_' + request.receiver.campaign).get();

            if (doc.empty) {
                return
            }

            const message = doc.docs[0].data().lastMessage;

            lastMessage.value =  {
                ...message,
                campName: message.uid === request.sender.uid ? request.sender.title : request.receiver.title,
                campPic: message.uid === request.sender.uid ? 
                    request.sender.thumbnails && request.sender.thumbnails.small || request.sender.image : 
                    request.receiver.thumbnails && request.receiver.thumbnails.small || request.receiver.image
            }
        } catch(err) {
            console.log(err);
        } finally {
            lastMessage.value = { ...lastMessage.value, loading: false }
        }

    }

    onMounted(() => {
        if(request.messageData){
            lastMessage.value = request.messageData
            return;
        }
        setMessage();
    })

    return {
        lastMessage
    }

}

export default useMessage
